import React, { Suspense, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fetchManufacturerTransactionDemographics } from '../../../../services/Http/ManufacturerApi';
import { toast } from 'react-toastify';

const ReactApexChart = React.lazy(() => import('react-apexcharts'));

const ManufacturerTransactionsStatistics = ({ period }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const response = await fetchManufacturerTransactionDemographics({ period });
                setData(response);
            } catch (error) {
                toast.error(t('ManufacturerTransactions.errors.loadDemographics'));
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [period, t]);

    if (loading || !data) {
        return <Placeholder>{t('common.loading')}</Placeholder>;
    }

    return (
        <Grid>
            <ChartCard>
                <h4>{t('ManufacturerTransactions.statistics.gender')}</h4>
                <Suspense fallback={<Placeholder>…</Placeholder>}>
                    <ReactApexChart type="pie" height={320} options={{ labels: Object.keys(data.gender_summary || {}) }} series={Object.values(data.gender_summary || {})} />
                </Suspense>
            </ChartCard>
            <ChartCard>
                <h4>{t('ManufacturerTransactions.statistics.age')}</h4>
                <Suspense fallback={<Placeholder>…</Placeholder>}>
                    <ReactApexChart type="bar" height={320} options={{ xaxis: { categories: Object.keys(data.age_group_summary || {}) } }} series={[{ name: t('ManufacturerTransactions.statistics.buyers'), data: Object.values(data.age_group_summary || {}) }]} />
                </Suspense>
            </ChartCard>
            <ChartCard>
                <h4>{t('ManufacturerTransactions.statistics.countries')}</h4>
                <Suspense fallback={<Placeholder>…</Placeholder>}>
                    <ReactApexChart type="pie" height={320} options={{ labels: Object.keys(data.country_summary || {}) }} series={Object.values(data.country_summary || {})} />
                </Suspense>
            </ChartCard>
            <ChartCard>
                <h4>{t('ManufacturerTransactions.statistics.venues')}</h4>
                <Suspense fallback={<Placeholder>…</Placeholder>}>
                    <ReactApexChart type="bar" height={320} options={{ xaxis: { categories: Object.keys(data.venue_summary || {}) } }} series={[{ name: t('ManufacturerTransactions.statistics.venues'), data: Object.values(data.venue_summary || {}) }]} />
                </Suspense>
            </ChartCard>
        </Grid>
    );
};

export default ManufacturerTransactionsStatistics;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
`;

const ChartCard = styled.div`
    border: 1px solid rgba(130, 22, 146, 0.15);
    border-radius: 12px;
    padding: 1rem;
`;

const Placeholder = styled.div`
    text-align: center;
    padding: 2.5rem;
`;
